module.exports = {
      id: "back-icon-usage",
      viewBox: "0 0 7.828 12.828",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#back-icon",
      toString: function () {
        return this.url;
      }
    }